
import { Vue } from "vue-class-component";

export default class Notebook extends Vue {}
